import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#FDFBF7] border border-[#E5E0D8] p-10">
        <img src="/images/logo.png" alt="" className="h-20 w-20 mx-auto mb-4 object-contain" />
        <h1 className="font-serif text-3xl text-center text-[#1A1A1A] mb-1">Administration</h1>
        <p className="text-center text-sm text-[#1A1A1A]/60 mb-8">Le Bistrot de la Neuve</p>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.25em] text-[#1A1A1A]/70">Email</label>
            <input
              type="email"
              value={email}
              data-testid="admin-email-input"
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="mt-1 w-full bg-white border border-[#E5E0D8] px-4 py-3 focus:outline-none focus:ring-1 focus:ring-[#A61C24] focus:border-[#A61C24]"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.25em] text-[#1A1A1A]/70">Mot de passe</label>
            <input
              type="password"
              value={password}
              data-testid="admin-password-input"
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="mt-1 w-full bg-white border border-[#E5E0D8] px-4 py-3 focus:outline-none focus:ring-1 focus:ring-[#A61C24] focus:border-[#A61C24]"
            />
          </div>
          {err && <div className="text-sm text-[#A61C24]" data-testid="login-error">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#A61C24] hover:bg-[#8B151E] text-white py-3 text-xs uppercase tracking-[0.25em] disabled:opacity-50 transition-colors"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
